import React from 'react'
import { Box, Container, Divider, Tab, Tabs, Toolbar } from '@material-ui/core'
import { Link, useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Sidebar } from './Sidebar'
import { VersionsSelector } from './VersionsSelector'
import { useLayoutStyles } from './use-layout-styles'
import { ProjectSubLayoutProps } from './ProjectSubDataLayout'
import { CommonProjectTitle } from './CommonProjectTitle'

type TabData = {
  id: string
  title: string
  path: string
}

type Props = ProjectSubLayoutProps & {
  title: string
  sidebarContent: React.ReactElement
  menu?: React.ReactElement
  tabs?: TabData[]
}

export function ProjectSubLayoutBase({
  title,
  sidebarContent,
  menu,
  tabs,
  children,
}: Props): React.ReactElement {
  const classes = useLayoutStyles()
  const history = useHistory()

  const activeTabIndex = tabs?.findIndex((tab) =>
    history.location.pathname.endsWith(tab.path),
  )

  return (
    <>
      <Helmet title={title} />

      <Sidebar omitPadding>
        <Toolbar />
        {sidebarContent}
      </Sidebar>

      <main className={classes.content}>
        <Container>
          <Box display="flex" justifyContent="space-between">
            <CommonProjectTitle title={title} />
            {menu}
          </Box>

          <Divider />
          <VersionsSelector />

          {tabs && (
            <Tabs value={activeTabIndex}>
              {tabs.map((tab) => (
                <Tab
                  key={tab.id}
                  id={tab.id}
                  label={tab.title}
                  component={Link}
                  to={tab.path}
                />
              ))}
            </Tabs>
          )}
        </Container>

        <Divider />

        {children}
      </main>
    </>
  )
}
